<template>
    <MiniModalCustom :is-open="props.show" @close="emit('close')">
        <div class="flex justify-between pt-4">
            <h3 class="font-bold text-lg">Select Project</h3>
            <div class="flex justify-center">
                <button
                    class="
                        bg-primary
                        rounded-lg
                        py-2
                        px-3
                        text-white text-md
                        flex
                        items-center
                        gap-2
                    "
                    @click="state.isCreateMode = true"
                    v-if="!state.isCreateMode && !state.isEditMode"
                >
                    <ion-icon name="add-outline"></ion-icon>
                </button>
            </div>
        </div>
        <div class="my-3">
            <div
                v-if="state.isCreateMode"
                class="flex gap-2 items-center w-full"
            >
                <input
                    v-model="state.projectName"
                    class="bg-gray-100 rounded-lg py-2 px-3 text-xs w-full"
                    placeholder="Project Name"
                />

                <button
                    class="
                        bg-primary
                        rounded-lg
                        py-2
                        px-3
                        text-white text-xs
                        flex
                        items-center
                        gap-1
                    "
                    @click="create"
                >
                    <ion-icon name="save-outline"></ion-icon>
                    Save
                </button>
                <button
                    class="
                        bg-gray-400
                        rounded-lg
                        py-2
                        px-3
                        text-white text-xs
                        flex
                        items-center
                        gap-1
                    "
                    @click="state.isCreateMode = false"
                >
                    <ion-icon name="close-outline"></ion-icon>
                    Cancel
                </button>
            </div>

            <table class="mt-6" v-if="state.projects.length">
                <tbody>
                    <tr
                        v-for="project in state.projects"
                        :key="project.id"
                        class="border-b border-gray-200"
                    >
                        <td class="text-left text-sm p-2 w-[100%]">
                            <span
                                v-if="state.isEditMode !== project.id"
                                class="cursor-pointer"
                                @click="select(project)"
                            >
                                {{ project.name }}
                            </span>
                            <div v-else class="flex gap-2">
                                <input
                                    v-model="state.projectName"
                                    class="
                                        bg-gray-100
                                        rounded-lg
                                        py-2
                                        px-3
                                        text-xs
                                        w-full
                                    "
                                    placeholder="Project Name"
                                />

                                <button
                                    class="
                                        bg-primary
                                        rounded-lg
                                        py-2
                                        px-3
                                        text-white text-xs
                                        flex
                                        items-center
                                        gap-1
                                    "
                                    @click="update(project)"
                                >
                                    <ion-icon name="save-outline"></ion-icon>
                                    Save
                                </button>
                                <button
                                    class="
                                        bg-gray-400
                                        rounded-lg
                                        py-2
                                        px-3
                                        text-white text-xs
                                        flex
                                        items-center
                                        gap-1
                                    "
                                    @click="state.isEditMode = null"
                                >
                                    <ion-icon name="close-outline"></ion-icon>
                                    Cancel
                                </button>
                            </div>
                        </td>
                        <td class="text-left">
                            <a
                                class="text-primary text-sm cursor-pointer"
                                @click="select(project)"
                                >Open</a
                            >
                        </td>
                        <td class="text-left">
                            <a
                                class="text-primary text-sm ml-2 cursor-pointer"
                                @click="edit(project)"
                                >Edit</a
                            >
                        </td>
                        <td class="text-left">
                            <a
                                class="text-red-500 text-sm ml-2 cursor-pointer"
                                @click="destroy(project)"
                                >Delete</a
                            >
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                class="text-gray-500 italic my-auto mx-auto text-center mb-5"
                v-if="state.projects.length === 0 && !state.isCreateMode"
            >
                No projects found
            </div>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import { defineEmits, reactive, onMounted, defineProps } from "vue";
import emitter from "tiny-emitter/instance";

const emit = defineEmits(["close", "select"]);

const props = defineProps({
    show: {
        type: Boolean,
    },
});

const state = reactive({
    projects: [],
    projectName: null,
    isEditMode: null,
    isCreateMode: false,
});

async function getData() {
    const resp = await axios.get("/project/list");
    state.projects = resp.data;
}

function select(project) {
    emit("select", project);
    emit("close");
    emitter.emit("select-project", project);
}

async function create() {
    await axios.post("/project", {
        name: state.projectName,
        teamId: props.teamId,
    });
    state.projectName = "";
    state.isCreateMode = false;
    getData();
}
async function update(project) {
    await axios.post(`/project/${project.id}/update`, {
        name: state.projectName,
    });
    state.projectName = "";
    state.isEditMode = null;
    getData();
}

async function destroy(project) {
    await axios.post(`/project/${project.id}/delete`);
    getData();
}

function edit(project) {
    state.isEditMode = project.id;
    state.projectName = project.name;
}

onMounted(() => {
    getData();
});
</script>
